import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import Login from "./views/Login";
import DefinePassword from "./views/DefinePassword";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import Account from "./views/Account";
import Contact from "./views/Contact";
import Dashboard from "./views/Dashboard";
import Configs from "./views/Configs";
import Products from "./views/Products";
import Transactions from "./views/Transactions";
import Accesses from "./views/Accesses";
import Feedbacks from "./views/Feedbacks";
import BuyNowPayLater from "./views/BuyNowPayLater";
import Vendings from "./views/Vendings";

// prevent NavigationDuplicated error
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: Login,
      beforeEnter: logout
    },
    {
      path: "/forgot-password",
      name: "forgotpassword",
      component: ForgotPassword,
      beforeEnter: logout
    },
    {
      path: "/define-password",
      name: "define-password",
      component: DefinePassword,
      beforeEnter: logout
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: ResetPassword,
      beforeEnter: logout
    },
    {
      path: "/account",
      name: "account",
      component: Account,
      beforeEnter: checkAuth
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
      beforeEnter: checkAuth
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      beforeEnter: checkAuth
    },
    {
      path: "/configs",
      name: "configs",
      component: Configs,
      beforeEnter: checkAuth
    },
    {
      path: "/products",
      name: "products",
      component: Products,
      beforeEnter: checkAuth
    },
    {
      path: "/transactions",
      name: "transactions",
      component: Transactions,
      beforeEnter: checkAuth
    },
    {
      path: "/buy-now-pay-later",
      name: "buy-now-pay-later",
      component: BuyNowPayLater,
      beforeEnter: checkAuth
    },
    {
      path: "/accesses",
      name: "accesses",
      component: Accesses,
      beforeEnter: checkAuth
    },
    {
      path: "/feedbacks",
      name: "feedbacks",
      component: Feedbacks,
      beforeEnter: checkAuth
    },
    {
      path: "/vendings",
      name: "vendings",
      component: Vendings,
      beforeEnter: checkAuth
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

function checkAuth(to, from, next) {
  let permissions = store.getters.permissions;
  if (store.getters.isAuthenticated) {
    if (to.name === "feedbacks" && !permissions.canSeeUserStoreFeedbacks) {
      next("/dashboard");
    } else if (
      to.name === "vendings" &&
      !permissions.vending?.canSeeDashboard
    ) {
      if (from.name !== "dashboard") {
        next("/dashboard");
      }
    } else {
      next();
    }
  } else {
    next("/");
  }
}

function logout(to, from, next) {
  store.dispatch("clearAccountData");
  store.dispatch("clearStores");
  store.dispatch("setStoreBeingManaged", null);
  store.dispatch("logout");
  next();
}
